import React, { useEffect, useState } from "react";
import {
  FaUser,
  FaAddressBook,
  FaIdCard,
  FaShieldAlt,
  FaStethoscope,
  FaHistory,
  FaUserFriends,
  FaMoneyCheck,
  FaClipboardCheck,
  FaHospitalAlt,
  FaPlusCircle,
  FaBed,
  FaSpinner,
} from "react-icons/fa";
import PersonalDetails from "../components/PersonalDetails";
import ContactInfo from "../components/ContactInfo";
import IdentificationDetails from "../components/IdentificationDetails";
import HealthInsurance from "../components/HealthInsurance";
import ReferrerInfo from "../components/ReferrerInfo";
import MedicalHistory from "../components/MedicalHistory";
import NextOfKin from "../components/NextOfKin";
import ModeOfPayment from "../components/ModeOfPayment";
import ConsentAcknowledgment from "../components/ConsentAcknowledgment";
import HospitalInfo from "../components/HospitalInfo";
import AdditionalInfo from "../components/AdditionalInfo";
import WardAllocation from "../components/WardAllocation";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useCreateItem } from "../../_helper/actions/mutation/items";
import { useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

export default function PatientRegistration() {
  const [currentStep, setCurrentStep] = useState(0);
  const [existingUserData, setExistingUserData] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [formData, setFormData] = useState({
    user_details: {
      id: null,
      phone: "",
      full_name: "",
      gender: "",
      dob: "",
      marital_status: "",
      country: "",
      language: "",
      blood_group: "",
      selectedPatient: null,
      residency_address: "",
      temporary_address: "",
      email: "",
      caste: "",
      occupation: "",
      family_history: "",
      patient_identification: {
        government_id_proof: "",
        government_id_proof_img: "",
        social_security_number: "",
      },
      patient_insurance_details: {
        insurance_provider: "",
        insurance_policy_number: "",
        insurance_validity: "",
        coverage_details: "",
        scheme_no: "",
        scheme_type: "",
        scheme: "",
        insurance_card_img: "",
      },
      patient_past_medical_history: {
        preexisting_conditions: "",
        past_surgical_history: "",
        current_medication: "",
        family_medical_history: "",
        immunization_history: "",
      },
    },
    referrer_details: {
      referring_doctor: "",
      referring_hospital: "",
      referral_letter: "",
      preliminary_diagnosis_details: "",
      diagnosis_report: "",
    },
    IPDPayment_id: {
      payment_type: "",
      bank_name: "",
      trasaction_id: "",
      amount: "",
      purpose: "",
    },

    primary_contact_no: "",
    secondary_contact_no: "",
    emergency_contact_name: "",
    emergency_contact_no: "",
    emergency_contact_relation: "",
    current_symptoms: [],
    assigned_doctor: [],
    addmission_type: "",
    dietary_preferences: "",
    disability_status: "",
  });

  const [isMenuCollapsed, setIsMenuCollapsed] = useState(false);
  const [clinic] = useAtom(clinicAtom);

  const { data: existingUser, isLoading: existingUserLoading } = useItemsFilter(
    ApiEndPoint?.USERS,
    `?action=getSearchPatient&clinic_id=${clinic?.id}&backend=True&family_id=${formData?.user_details?.phone}`,

    formData?.user_details?.phone?.length >= 10 && clinic?.id ? true : false,
    "",
    0
  );

  const createMutation = useCreateItem(ApiEndPoint?.IPD);

  console.log("Form Data", formData);

  useEffect(() => {
    if (existingUser) {
      const options = existingUser.map((user) => ({
        value: user.id,
        label: user.full_name,
        gender: user.gender,
        dob: user.dob,
        age: user.age,
        user: user.user,
        id: user.id,
      }));

      setExistingUserData(options || []);
    }
  }, [existingUser]);

  const handleNext = async () => {
    const stepKeys = Object.keys(formData);
    const currentKey = stepKeys[currentStep];
    const IpdId = searchParams.get("id");

    if (!IpdId) {
      // POST request to create IPD
      const payload = {
        action: "postIpds",
        clinic_id: clinic?.id,
        ...formData,
      };
      createMutation.mutate(payload, {
        onSuccess: (data) => {
          setCurrentStep(currentStep + 1);
          console.log("IPD Created", data);
        },
        onError: (error) => {
          toast.error("Error creating IPD", error);
        },
      });
    } else {
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleDataChange = (data, mapping) => {
    setFormData((prevData) => {
      const updatedData = { ...prevData };

      Object.keys(mapping).forEach((fieldKey) => {
        const targetPath = mapping[fieldKey]; // Path in dot notation, e.g., "user_details.patient_identification"

        if (targetPath === "topLevel") {
          updatedData[fieldKey] = data[fieldKey]; // Update top-level fields
        } else {
          // Handle nested paths using dot notation
          const keys = targetPath.split(".");
          let current = updatedData;

          keys.forEach((key, index) => {
            if (index === keys.length - 1) {
              // Last key: update the field
              if (Array.isArray(current[key])) {
                // Update array values
                current[key] = current[key].map((item, i) =>
                  i === fieldKey ? data[fieldKey] : item
                );
              } else {
                current[key] = { ...current[key], [fieldKey]: data[fieldKey] };
              }
            } else {
              // Intermediate keys: ensure they exist
              if (!current[key]) {
                current[key] = {};
              }
              current = current[key];
            }
          });
        }
      });

      return updatedData;
    });
  };

  const steps = [
    {
      id: "personalDetails",
      label: "Personal Details",
      icon: <FaUser />,
      component: (
        <PersonalDetails
          data={formData.user_details}
          onChange={(updatedData) =>
            handleDataChange(updatedData, {
              phone: "user_details",
              full_name: "user_details",
              gender: "user_details",
              dob: "user_details",
              marital_status: "user_details",
              country: "user_details",
              language: "user_details",
              blood_group: "user_details",
              id: "user_details",
              user: "user_details",
            })
          }
          existingUser={
            formData?.user_details?.phone?.length === 10 ? existingUserData : []
          }
          isLoading={existingUserLoading}
        />
      ),
    },
    {
      id: "contactInfo",
      label: "Contact Info",
      icon: <FaAddressBook />,
      component: (
        <ContactInfo
          data={{
            ...formData.user_details, // Pass user_details fields for editing
            primary_contact_no: formData.primary_contact_no,
            secondary_contact_no: formData.secondary_contact_no,
          }}
          onChange={(data) =>
            handleDataChange(data, {
              residency_address: "user_details",
              temporary_address: "user_details",
              email: "user_details",
              primary_contact_no: "topLevel",
              secondary_contact_no: "topLevel",
              emergency_contact_name: "topLevel", // Add to emergencyContacts
              emergency_contact_no: "topLevel",
            })
          }
        />
      ),
    },
    {
      id: "identificationDetails",
      label: "Identification Details",
      icon: <FaIdCard />,
      component: (
        <IdentificationDetails
          data={{
            ...formData.user_details.patient_identification,
            caste: formData.user_details.caste,
            occupation: formData.user_details.occupation,
            family_history: formData.user_details.family_history,
          }}
          onChange={(updatedData) =>
            handleDataChange(updatedData, {
              government_id_proof: "user_details.patient_identification",
              government_id_proof_img: "user_details.patient_identification",
              social_security_number: "user_details.patient_identification",
              caste: "user_details",
              occupation: "user_details",
              family_history: "user_details",
            })
          }
        />
      ),
    },
    {
      id: "healthInsurance",
      label: "Health Insurance",
      icon: <FaShieldAlt />,
      component: (
        <HealthInsurance
          data={formData.user_details.patient_insurance_details}
          onChange={(updatedData) =>
            handleDataChange(updatedData, {
              insurance_provider: "user_details.patient_insurance_details",
              insurance_policy_number: "user_details.patient_insurance_details",
              insurance_validity: "user_details.patient_insurance_details",
              coverage_details: "user_details.patient_insurance_details",
              scheme_no: "user_details.patient_insurance_details",
              scheme_type: "user_details.patient_insurance_details",
              scheme: "user_details.patient_insurance_details",
              insurance_card_img: "user_details.patient_insurance_details",
            })
          }
        />
      ),
    },
    {
      id: "referrerInfo",
      label: "Referrer Info",
      icon: <FaStethoscope />,
      component: (
        <ReferrerInfo
          data={formData.referrer_details}
          onChange={(updatedData) =>
            handleDataChange(updatedData, {
              referring_doctor: "referrer_details",
              referring_hospital: "referrer_details",
              referral_letter: "referrer_details",
              preliminary_diagnosis_details: "referrer_details",
              diagnosis_report: "referrer_details",
            })
          }
        />
      ),
    },
    {
      id: "medicalHistory",
      label: "Medical History",
      icon: <FaHistory />,
      component: (
        <MedicalHistory
          doctors={[
            {
              id: "DOC001",
              name: "Dr. Mukesh Phalak",
              specialization: "Spine Surgeon (Ortho)",
            },
            {
              id: "DOC002",
              name: "Dr. Anuja Phalak",
              specialization: "General Physician & Heart Care",
            },
          ]}
          data={{
            ...formData.user_details.patient_past_medical_history,
            current_symptoms: formData.current_symptoms || [],
            assigned_doctor: formData.assigned_doctor || "",
          }}
          onChange={(updatedData) =>
            handleDataChange(updatedData, {
              preexisting_conditions:
                "user_details.patient_past_medical_history",
              current_medication: "user_details.patient_past_medical_history",
              past_surgical_history:
                "user_details.patient_past_medical_history",
              immunization_history: "user_details.patient_past_medical_history",
              family_medical_history:
                "user_details.patient_past_medical_history",
              current_symptoms: "topLevel",
              assigned_doctor: "topLevel",
            })
          }
        />
      ),
    },
    {
      id: "nextOfKin",
      label: "Next of Kin",
      icon: <FaUserFriends />,
      component: (
        <NextOfKin
          data={{
            emergency_contact_name: formData.emergency_contact_name,
            emergency_contact_no: formData.emergency_contact_no,
            emergency_contact_relation: formData.emergency_contact_relation,
          }}
          onChange={(updatedData) =>
            handleDataChange(updatedData, {
              emergency_contact_name: "topLevel",
              emergency_contact_no: "topLevel",
              emergency_contact_relation: "topLevel",
            })
          }
        />
      ),
    },
    {
      id: "modeOfPayment",
      label: "Mode of Payment",
      icon: <FaMoneyCheck />,
      component: (
        <ModeOfPayment
          data={formData.IPDPayment_id}
          onChange={(updatedData) =>
            handleDataChange(updatedData, {
              payment_type: "IPDPayment_id",
              bank_name: "IPDPayment_id",
              trasaction_id: "IPDPayment_id",
              amount: "IPDPayment_id",
              purpose: "IPDPayment_id",
            })
          }
        />
      ),
    },
    {
      id: "consentAcknowledgment",
      label: "Consent & Acknowledgment",
      icon: <FaClipboardCheck />,
      component: (
        <ConsentAcknowledgment
          data={formData.consentAcknowledgment}
          onChange={(data) => handleDataChange("consentAcknowledgment", data)}
        />
      ),
    },
    {
      id: "hospitalInfo",
      label: "Hospital Info",
      icon: <FaHospitalAlt />,
      component: (
        <HospitalInfo
          data={{
            ...formData.hospitalInfo,
            admission_type: formData.addmission_type, // Pass top-level field
          }}
          onChange={(updatedData) =>
            handleDataChange(updatedData, {
              patient_id: "hospitalInfo",
              admission_type: "topLevel", // Update top-level admission_type
            })
          }
        />
      ),
    },
    {
      id: "wardAllocation",
      label: "Ward Allocation",
      icon: <FaBed />,
      component: (
        <WardAllocation
          wards={[
            {
              wardId: "W001",
              name: "General Ward",
              costPerDay: 500,
              availableBeds: 10,
            },
            {
              wardId: "W002",
              name: "Private Ward",
              costPerDay: 2000,
              availableBeds: 5,
            },
            {
              wardId: "W003",
              name: "ICU",
              costPerDay: 5000,
              availableBeds: 2,
            },
          ]}
          data={formData.wardAllocation}
          onChange={(data) => handleDataChange("wardAllocation", data)}
        />
      ),
    },
    {
      id: "additionalInfo",
      label: "Additional Info",
      icon: <FaPlusCircle />,
      component: (
        <AdditionalInfo
          data={{
            dietary_preferences: formData.dietary_preferences,
            disability_status: formData.disability_status,
          }}
          onChange={(updatedData) =>
            handleDataChange(updatedData, {
              dietary_preferences: "topLevel",
              disability_status: "topLevel",
            })
          }
        />
      ),
    },
  ];

  const isLastStep = currentStep === steps.length - 1;

  return (
    <div className="min-h-screen flex bg-gray-50">
      {/* Vertical Menu */}
      <div
        className={`bg-white shadow-lg transition-all duration-300 ${
          isMenuCollapsed ? "w-16" : "w-64"
        }`}
      >
        <div className="flex items-center justify-between p-4 border-b">
          <h2
            className={`text-lg font-bold transition-opacity ${
              isMenuCollapsed ? "opacity-0" : "opacity-100"
            }`}
          >
            Registration Menu
          </h2>
          <button
            className="text-gray-500 hover:text-gray-700"
            onClick={() => setIsMenuCollapsed(!isMenuCollapsed)}
          >
            {isMenuCollapsed ? "▶" : "◀"}
          </button>
        </div>
        <ul className="space-y-2 mt-4">
          {steps.map((step, index) => (
            <li
              key={step.id}
              onClick={() => setCurrentStep(index)}
              className={`flex items-center p-3 rounded-lg cursor-pointer text-sm md:text-base ${
                currentStep === index
                  ? "bg-blue-100 text-blue-600 font-bold"
                  : "hover:bg-gray-100 text-gray-600"
              }`}
            >
              <span className="text-xl">{step.icon}</span>
              {!isMenuCollapsed && <span className="ml-3">{step.label}</span>}
            </li>
          ))}
        </ul>
      </div>

      {/* Form Section */}
      <div className="flex-grow p-6 md:p-12 bg-white shadow-md mx-auto max-w-5xl">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-700">
            {steps[currentStep].label}
          </h1>
          <p className="text-gray-500 mt-2">
            Step {currentStep + 1} of {steps.length}
          </p>
        </div>

        {/* Dynamic Component Rendering */}
        <div>{steps[currentStep].component}</div>

        {/* Navigation Buttons */}
        <div className="flex justify-between items-center mt-8">
          <button
            className={`px-6 py-2 rounded-md text-white text-sm md:text-base ${
              currentStep === 0
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
            }`}
            disabled={currentStep === 0}
            onClick={handlePrevious}
          >
            Previous
          </button>
          <button
            className={`px-6 py-2 rounded-md text-white text-sm md:text-base ${
              isLastStep
                ? "bg-green-600 hover:bg-green-700"
                : "bg-blue-600 hover:bg-blue-700"
            }`}
            onClick={handleNext}
          >
            {createMutation.isLoading ? (
              <FaSpinner className="animate-spin mr-2" /> // Show spinner
            ) : isLastStep ? (
              "Finish"
            ) : (
              "Save & Next"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
